<template>
  <div>
    <v-data-table
      :single-select="true"
      item-key="id"
      :show-select="select"
      :headers="headers || []"
      :items="items || []"
      :search="search"
      :locale="'ru'"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      dense
      hide-default-footer
      class="customers-table elevation-0"
      @page-count="pageCount = $event"
    >
      <template v-if="select" #item.data-table-select="{ item }">
        <v-radio-group v-model="selected" hide-details class="mt-0">
          <v-radio
            :class="{
              'radio-ps': item.type === 'ps',
              'radio-company': item.type === 'company'
            }"
            :value="item.id"
            :color="item.type === 'company' ? 'red' : 'blue'"
            @change="changeCompany(item.id, item.name)"
          />
        </v-radio-group>
      </template>

      <template #item.name="{ item }">
        <v-row align="center">
          <v-col cols="10">
            <b
              @click="onCompanyTitleClick(item)"
              class="pa-0 company-button"
              style="display: inline-block; cursor: pointer; letter-spacing: 0; line-height: 1.4; max-width: 250px"
            >
              {{ item.name }}
            </b>
          </v-col>

          <svg
            v-if="item.isNS"
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            :title="mess.ns_article"
          >
            <title>{{ mess.ns_article }}</title>
            <path
              d="M7.5 0C6.01664 0 4.5666 0.439867 3.33323 1.26398C2.09986 2.08809 1.13856 3.25943 0.570907 4.62987C0.00324965 6.00032 -0.145275 7.50832 0.144114 8.96318C0.433503 10.418 1.14781 11.7544 2.1967 12.8033C3.2456 13.8522 4.58197 14.5665 6.03683 14.8559C7.49168 15.1453 8.99968 14.9968 10.3701 14.4291C11.7406 13.8614 12.9119 12.9001 13.736 11.6668C14.5601 10.4334 15 8.98336 15 7.5C14.9979 5.51154 14.207 3.60513 12.8009 2.19907C11.3949 0.793018 9.48847 0.00215068 7.5 0ZM7.5 13.75C6.26387 13.75 5.0555 13.3834 4.02769 12.6967C2.99988 12.0099 2.1988 11.0338 1.72576 9.89177C1.25271 8.74973 1.12894 7.49307 1.3701 6.28069C1.61125 5.06831 2.20651 3.95466 3.08059 3.08058C3.95466 2.2065 5.06831 1.61125 6.28069 1.37009C7.49307 1.12893 8.74974 1.25271 9.89178 1.72575C11.0338 2.1988 12.0099 2.99988 12.6967 4.02769C13.3834 5.05549 13.75 6.26387 13.75 7.5C13.7482 9.15705 13.0891 10.7457 11.9174 11.9174C10.7457 13.0891 9.15705 13.7482 7.5 13.75Z"
              fill="#EA5432"
            />
            <path
              d="M10.4167 4.29181V9.9551C10.4167 10.4649 10.0813 10.8762 9.58196 10.9789C9.50642 10.9943 9.43146 11.0019 9.35796 11.0019C8.94642 11.0019 8.58154 10.7648 8.41121 10.3666L10.4167 4.29181ZM5.89191 4.93235L5.89194 4.93241L8.25031 10.4355C8.25033 10.4355 8.25034 10.4355 8.25036 10.4356C8.44786 10.8971 8.87538 11.1769 9.35796 11.1769C9.44351 11.1769 9.53022 11.1681 9.61704 11.1503L9.6172 11.1503C10.1979 11.0309 10.5917 10.548 10.5917 9.9551L10.5917 4.29181L10.5917 4.29114C10.5912 4.14748 10.5342 4.02751 10.4403 3.9455C10.3497 3.86644 10.2344 3.83083 10.1252 3.8308C10.0159 3.83077 9.90067 3.86633 9.81003 3.94537C9.71603 4.02735 9.65904 4.14731 9.65837 4.29101V4.29181V9.9551C9.65837 10.1277 9.54938 10.2111 9.42969 10.236C9.36818 10.2481 9.30353 10.244 9.24897 10.2205C9.19802 10.1986 9.14564 10.1556 9.10811 10.0681L6.74973 4.56472L6.74971 4.56469C6.51606 4.01972 5.96255 3.73058 5.38284 3.85032C4.80215 3.96944 4.40837 4.45233 4.40837 5.04519L4.40837 10.7085L4.40838 10.7091C4.40893 10.8528 4.4659 10.9728 4.55988 11.0548C4.65048 11.1339 4.76574 11.1695 4.875 11.1695C4.98425 11.1695 5.09955 11.134 5.19019 11.0549C5.28421 10.9729 5.34116 10.8529 5.34171 10.7091V10.7085V5.04548C5.34171 4.87221 5.45116 4.78902 5.57074 4.76455L5.53567 4.59311L5.57053 4.7646C5.63116 4.75227 5.69588 4.75605 5.75076 4.77967C5.80186 4.80165 5.85443 4.84478 5.89191 4.93235Z"
              fill="#EA5432"
              stroke="#EA5432"
              stroke-width="0.35"
            />
          </svg>
        </v-row>
      </template>

      <template #item.send_to_ns="{ item }">
        <v-btn
          :loading="Object.hasOwn(item, 'inProcessOfSending') && item.inProcessOfSending"
          :disabled="item.isNS"
          color="primary"
          outlined
          depressed
          @click="$emit('send-to-ns:company', item)"
        >
          Send to NS
        </v-btn>
      </template>

      <template #item.create_deal="{ item }">
        <v-btn
          @click="$emit('open-create-lead-dialog', item)"
          small
          depressed
          outlined
          color="primary"
        >
          {{ mess.dialog_create_lead_open_button }}
        </v-btn>
      </template>

      <template #item.ib="{ item }">
        <a
          href="/personal/my_customers/installations_maintenance/"
          target="_blank"
          style="color: #000; text-decoration: none"
          ><b>{{ item.ib }}</b></a
        >
      </template>

      <template #item.cp="{ item }">
        <a
          href="/personal/my_customers/installations_maintenance/"
          target="_blank"
          style="text-decoration: none"
          ><b :style="{ color: siteColors.primary }">{{ item.cp }}</b></a
        >
      </template>

      <template #item.mve="{ item }">
        <b :style="{ color: siteColors.primary }">{{ item.mve }}</b>
      </template>

      <template #item.cp_mve="{ item }">
        <b>{{ item.cp_mve }}</b>
      </template>

      <template #item.deals="{ item }">
        <v-btn
          tag="a"
          :href="item.deals_url"
          target="_blank"
          small
          outlined
          color="#9c9c9c"
          width="28"
          height="28"
          min-width="28"
          >{{ item.deals }}</v-btn
        >
      </template>

      <template #item.wishlists="{ item }">
        <b>{{ item.wishlists }}</b>
      </template>

      <template #item.requests="{ item }">
        <b>{{ item.requests }}</b>
      </template>
    </v-data-table>

    <div class="text-center pt-5">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="total"
      />
    </div>

    <Snackbar
      v-model="snackbar"
      :snackbar="snackbar"
      :snackbar-data="snackbarData"
    />
  </div>
</template>

<script>
// Services
import { companiesService } from "@/services/companies-service";
import axios from "axios";
import Snackbar from "@/components/Snackbar";

export default {
  name: "CustomersTable",
  components: {
    Snackbar
  },
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 10
    },
    itemsPerPage: {
      type: Number,
      default: 20
    },
    search: {
      type: String,
      default: undefined
    },
    select: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update-company", "send-to-ns:company"],
  data() {
    return {
      page: 1,
      pageCount: 0,
      selected: -1,
      snackbar: false,
      snackbarData: undefined
    };
  },
  computed: {
    selectedCustomerId() {
      return this.$store.getters.selectedCustomer.id;
    }
  },
  watch: {
    selected(val) {
      const currentItem = this.items?.find(item => item.id === val);
      if (!this.items || !currentItem) return;

      this.$store.dispatch("setSelectedCustomer", currentItem);
      this.$emit("show-customer-card");
    },
    selectedCustomerId(val) {
      this.selected = val;
    }
  },
  methods: {
    changeCompany(id, name) {
      companiesService
        .setActiveCompany(id, name)
        .then(() => this.$emit("change-company", { id, name }));
    },
    onCompanyTitleClick({ id, name }) {
      this.$emit("open-company-info-dialog", { id, name });
      this.selected = id;
      setTimeout(() => this.changeCompany(id, name), 0);
    },
    openSnackBar(data) {
      this.snackbar = true;
      this.snackbarData = data;
    },
    async sendToNs(item) {
      try {
        const formData = new FormData();

        formData.append("company_id", item.id);
        formData.append("name", item.name);
        formData.append("isExists", true);

        await axios.post(
          "/local/ajax/addNewMyCustomerAndSendToNs.php",
          formData
        );

        this.$emit("update-company");
        this.openSnackBar({
          status: "success",
          message: `${this.mess.notification_added_to_ns}`
        });
      } catch (error) {
        console.error(error);
        this.openSnackBar({
          status: "error",
          message: `${this.mess.notification_added_to_ns_error}`
        });
      }
    }
  }
};
</script>

<style lang="scss">
.customers-table.v-data-table {
  thead tr {
    vertical-align: baseline;
    line-height: 1;
  }

  td {
    min-height: 26px;

    @media (min-width: 600px) {
      height: 60px !important;
    }
  }

  th {
    padding-top: 8px;
    padding-bottom: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.4;
    color: #9c9c9c;
  }

  .v-radio {
    margin-right: 0;
  }

  .v-input--selection-controls {
    padding-top: 0;
  }
}

.company-button {
  color: #1a1a1a;
  transition: color 250ms;

  &:hover {
    color: var(--v-primary-base);
  }
}

.v-pagination__item {
  outline: none;
  box-shadow: none;
  border: 1px solid #9c9c9c;
}

.v-pagination__navigation {
  outline: none;
  box-shadow: none;
  border: 1px solid #9c9c9c;
}

.radio-ps .v-icon.mdi-radiobox-blank {
  color: #2096f4;
}

.radio-company .v-icon.mdi-radiobox-blank {
  color: #f44335;
}
</style>
